import type { SortDescriptor } from "react-stately";

import { USER_ROLES } from "@nlc/shared-types";
import { useState } from "react";

import type { UserRole } from "@/features/auth/permissions/config";

import { FeaturePageLayout } from "@/features/shared/layout";

import { WhitelabelConfigsTable } from "./components/WhitelabelConfigsTable";
import { useListWhitelabelConfigs } from "./shared/hooks/useListWhitelabelConfigs";

export function ListWhitelabelConfigsPage() {
  const [inputValue, setInputValue] = useState("");
  const [sortDescriptor, setSortDescriptor] = useState<SortDescriptor>({
    column: "createdAt",
    direction: "descending",
  });

  const { data, isFetching } = useListWhitelabelConfigs();

  const configs = data?.data ?? [];

  const filteredConfigs = inputValue
    ? configs.filter(
        (c) =>
          c.partnerName.toLowerCase().includes(inputValue.toLowerCase()) ||
          c.customDomain?.toLowerCase().includes(inputValue.toLowerCase()),
      )
    : configs;

  return (
    <div className="p-xl">
      <FeaturePageLayout
        createButton={{
          href: "/whitelabel/create",
          label: "New Config",
          requiredRoles: [USER_ROLES.SUPER_ADMIN] as UserRole[],
        }}
        isLoading={isFetching}
        searchBar={{
          inputValue,
          setInputValue,
        }}
        title="Whitelabel Configs"
      >
        <WhitelabelConfigsTable
          configs={filteredConfigs}
          isLoading={isFetching}
          setSortDescriptor={setSortDescriptor}
          sortDescriptor={sortDescriptor}
        />
      </FeaturePageLayout>
    </div>
  );
}
